import { IconType } from "@kinomap-dev/ng-ui-lib/core";

type NotificationBase = {
    date: Date;
    isRead: boolean;
    icon: IconType;
    tip: string;
}

export type ContentNotificationType = 'WAITING_INTERVAL_EDIT' | 'AVAILABLE_CONTENT' | 'CONTENT_CONVERT' | 'CONTENT_REFUSED' | 'NEW_COMMENT' | 'PLANIFICATION_DATE_CHANGE' | 'PLANIFICATION_PUBLISH';
export type NotificationType = ContentNotificationType | 'KINO_MESSAGE';

export type ContentNotification = NotificationBase & {
    type: ContentNotificationType;
    contentTitle: string;
}

export type KinoNotification = NotificationBase & {
    type: 'KINO_MESSAGE';
    title: string;
}

export type Notification = ContentNotification | KinoNotification;

export function createNotification(raw: Omit<ContentNotification, 'icon' | 'tip'>): ContentNotification;
export function createNotification(raw: Omit<KinoNotification, 'icon'>): KinoNotification;
export function createNotification(raw: Omit<ContentNotification, 'icon' | 'tip'> | Omit<KinoNotification, 'icon'>): Notification {
    if (raw.type === 'KINO_MESSAGE') {
        return { ...raw, icon: NOTIFICATION_TYPE_ICONS['KINO_MESSAGE'] };
    }
    return { ...raw, icon: NOTIFICATION_TYPE_ICONS[raw.type], tip: NOTIFICATION_TYPE_TIPS[raw.type] };
}

export const NOTIFICATION_TYPE_MESSAGE: Record<ContentNotificationType, string> = {
    WAITING_INTERVAL_EDIT: 'Editer les intervals de votre contenu {content_name}.',
    AVAILABLE_CONTENT: 'Votre contenu {content_name} est disponible sur l’app.',
    CONTENT_CONVERT: 'Votre contenu {content_name} a été converti.',
    CONTENT_REFUSED: 'Votre contenu {content_name} n’est pas accepté.',
    NEW_COMMENT: 'Vous avez reçu un commentaire sur {content_name}',
    PLANIFICATION_PUBLISH: 'Votre contenu {content_name} planifié le {publish_date} vient d’être publié',
    PLANIFICATION_DATE_CHANGE: 'Votre contenu {content_name} ne pourra pas être publié à la date prévue ({publish_date})',
} as const;

export const NOTIFICATION_TYPE_TIPS: Record<ContentNotificationType, string> = {
    WAITING_INTERVAL_EDIT: 'Afin que votre contenu soit disponible sur l\'application, veuillez éditer les intervalles de votre entraînement.',
    AVAILABLE_CONTENT: 'Les utilisateurs vont pouvoir s\'entraîner sur votre contenu. Retrouvez les détails depuis la page "Mes contenus".',
    CONTENT_CONVERT: 'Vous pouvez le retrouver dans la page "Mes contenus".',
    CONTENT_REFUSED: 'Ne respectant pas les critères de qualité, votre contenu n\'est pas disponible sur l\'application. Retrouvez les détails depuis la page "Mes contenus".',
    NEW_COMMENT: 'Rendez-vous sur la page de votre contenu pour consulter et répondre au commentaire.',
    PLANIFICATION_PUBLISH: 'Votre contenu est maintenant visible par les utilisateurs de l\'application.',
    PLANIFICATION_DATE_CHANGE: 'La date de publication prévue n\'est plus disponible. Veuillez en choisir une nouvelle depuis la page "Mes contenus".',
} as const;

export const NOTIFICATION_TYPE_ICONS: Record<NotificationType, IconType> = {
    WAITING_INTERVAL_EDIT: 'edit',
    AVAILABLE_CONTENT: 'g_validate',
    CONTENT_CONVERT: 'upload',
    CONTENT_REFUSED: 'close',
    KINO_MESSAGE: 'mail',
    NEW_COMMENT: 'comment',
    PLANIFICATION_PUBLISH: 'agenda',
    PLANIFICATION_DATE_CHANGE: 'agenda',
} as const;